import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { 
  SharedDataService,
  SuppliersService,
  SupplierMail 
} from 'ngx-paf-common';
import { PilotageEndelTabComponent } from '../pilotage-endel-tab/pilotage-endel-tab.component';

@Component({
  selector: 'pilotage-mails',
  templateUrl: './pilotage-mails.component.html',
  styleUrls: ['./pilotage-mails.component.scss']
})
export class PilotageMailsComponent
  extends PilotageEndelTabComponent 
  implements OnInit {
  reloadTab(): void {
    this.loading=true;
    this.suppliersSvc.GetSupplierMails(this.supplierId).subscribe((results:SupplierMail[])=>{
      this.supplierMails=results;
      this.supplierMails.sortOnDateDesc('DateSent');
      this.supplierMails.forEach((mail:SupplierMail)=>mail.Body = mail.Body.replace('src="cid:', 'src="./assets/images/'));
      this.loading=false;
    });
  }
  
  constructor(public sharedDataSvc:SharedDataService,
      private suppliersSvc:SuppliersService,
      private modalService: NgbModal) { 
        super(sharedDataSvc);
      }

  supplierMails:SupplierMail[]=[];

  ngOnInit(): void {
    this.reloadTab();
  }

  selectedMail:SupplierMail=null;
  
  triggerModal(mail:SupplierMail,content: any) {
    this.selectedMail=mail;
    this.modalService.open(
      content,
      {
        ariaLabelledBy: 'modal-basic-title',
        size: 'xl',
        centered: true,
        animation: true,
        scrollable: true
      }).result;
  }

  mailSender(mail:SupplierMail):string{
    return mail.Contact?.EmailDiff || mail.Contact?.Email;
  }



}
